import { useEffect } from "react";
import { Html5Qrcode } from "html5-qrcode";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";

export function QrScanDialog({ open, onClose, onResult }) {
  useEffect(() => {
    if (!open) return;
    let scanner;
    const t = setTimeout(() => {
      scanner = new Html5Qrcode("qr-reader");
      scanner.start({ facingMode: "environment" }, { fps: 10, qrbox: 220 }, (text) => {
        scanner.stop().catch(() => {});
        onResult(text);
        onClose();
      }).catch(() => toast.error("Kamera tidak dapat dibuka. Ketik nomor tracking secara manual."));
    }, 300);
    return () => { clearTimeout(t); if (scanner?.isScanning) scanner.stop().catch(() => {}); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-sm">
        <DialogHeader><DialogTitle>Scan Label Bahan</DialogTitle></DialogHeader>
        <div id="qr-reader" data-testid="qr-reader" className="w-full min-h-[260px] bg-black/5 rounded" />
      </DialogContent>
    </Dialog>
  );
}
